import React from "react";
import { EntityType, RoutePath } from "shared/constants";
import { Button } from "@ds/ds-snam/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface IAddEntityButtonProps {
    entityType: EntityType
}
const AddEntityButton: React.FC<IAddEntityButtonProps> = (props): JSX.Element => {
    const { entityType } = props;
    const { t } = useTranslation(['contract', 'app']);

    const navigate = useNavigate();

    const getButtonLabel = () => {
        let labelSuffix: string = '';

        switch (entityType) {
            case EntityType.BUSINESS:
                labelSuffix = t('customer.customerList.addButton');//Inserisci anagrafica cliente
                break;
            case EntityType.CONTRACT:
                labelSuffix = t('contract.contractList.addButton');//Inserisci un contratto
                break;
            case EntityType.DRIVER:
                labelSuffix = t('drivers.driverList.addButton');//Inserisci autista
                break;
            case EntityType.TRANSPORTER:
                labelSuffix = t('transporter.transporterList.addButton');//Inserisci trasportatore
                break;
            case EntityType.TRANSPORTERDELEGATION:
                labelSuffix = t("transporter.delegationForm.title_1"); //delega trasportatore
                break;
            case EntityType.VEHICLE:
                labelSuffix = t('vehicle.vehicleList.addButton'); //Inserisci componente
                break;
            case EntityType.SHIPPER:
                labelSuffix = t('settings.shipperParameters.labels.2', { ns: 'contract' }); //Inserisci componente
                break;
            case EntityType.CUSTOMERDELEGATION:
                labelSuffix = t('customer.customerList.customerDelegation');// Delega cliente
                break;
            default:
                break;
        }

        return (entityType === EntityType.TRANSPORTERDELEGATION || entityType === EntityType.CUSTOMERDELEGATION) ? labelSuffix : t('general.buttons.addElement', { ns: 'app', what: labelSuffix });
    }
    const getRoutePath = () => {
        let routePath: RoutePath = RoutePath.ROOT;
        switch (entityType) {
            case EntityType.BUSINESS:
                routePath = RoutePath.CONTRACTS_NEW_CUSTOMER;
                break;
            case EntityType.CONTRACT:
                routePath = RoutePath.CONTRACTS_NEW_CONTRACT;
                break;
            case EntityType.DRIVER:
                routePath = RoutePath.CONTRACTS_NEW_DRIVER;
                break;
            case EntityType.TRANSPORTER:
                routePath = RoutePath.CONTRACTS_NEW_TRANSPORT;
                break;
            case EntityType.TRANSPORTERDELEGATION:
                routePath = RoutePath.CONTRACTS_NEW_DELEGATION;
                break;
            case EntityType.VEHICLE:
                routePath = RoutePath.CONTRACTS_NEW_VEHICLE;
                break;
            case EntityType.SHIPPER:
                routePath = RoutePath.SETTINGS_NEW_SHIPPER;
                break;
            case EntityType.CUSTOMERDELEGATION:
                routePath = RoutePath.CONTRACTS_CUSTOMER_DELEGATION;
                break;
            default:
                break;
        }
        return routePath;
    }


    return <Button
        buttonType="button"
        buttonUIVariant={(entityType === EntityType.TRANSPORTERDELEGATION || entityType === EntityType.CUSTOMERDELEGATION) ? "primary" : "secondary"}
        buttonSize="medium"
        buttonLabel={getButtonLabel()}//"Inserisci un [...depends on entity]"
        buttonIcon={(entityType === EntityType.TRANSPORTERDELEGATION || entityType === EntityType.CUSTOMERDELEGATION) ? "" : "icon-add"}
        buttonAriaLabel="new entity button"
        onClickEvent={() => {
            navigate(getRoutePath())
        }}
    ></Button>
}

export default AddEntityButton;